// components/KOTPrintLayout.js
import React from "react";

export default function KOTPrintLayout({ data, user }) {
    if (!data) return null;

    const kotId = data.kotId || data.id || "N/A";
    const seatingName = data.seatingName || data.seating_name || data.table || "N/A";
    const createdBy = data.createdBy || data.waiter || user.username;
    const displayProducts = data.products || data.items || [];
    
    const rawDate = data.createdAt || data.date || data.timestamp;
    const validDate = rawDate ? new Date(rawDate) : new Date();
    const displayDate = isNaN(validDate.getTime()) ? new Date() : validDate;

    return (
        <div className="hidden print:block print-receipt-container mx-auto text-black font-mono text-xs p-1">
            {/* Header details */}
            {/*<div className="text-center space-y-1 mb-3">
                {user?.restaurantLogo && (
                    <img src={user.restaurantLogo} alt="Logo" className="mx-auto h-10 w-10 object-contain" />
                )}
                <h1 className="text-base font-bold uppercase tracking-tight">{user?.restaurantName || "Atithi Dhaba"}</h1>
                <p className="text-[10px]">Atithi Dhaba Near airport thana.</p>
                <p className="text-[10px]">Contact: +91 9827383352</p>
            </div>

            <div className="border-b border-dashed border-black my-2"></div>
            */}
            {/* KOT Metadata details */}
            <div className="space-y-0.5 text-[14px] mb-2">
                <div className="font-bold text-center text-[18px] uppercase mb-3 mt-2">Atithi Dhaba (KOT)</div>
                <div className="grid grid-cols-12">
                    <div className="col-span-7"><strong>KOT ID:</strong> {kotId}</div>
                    <div className="col-span-3 text-[16px]">{displayDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</div> 
                </div>
                {/*<div><strong>Date & Time:</strong> {displayDate.toLocaleDateString()} | {displayDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</div>*/}
                <div className="grid grid-cols-12">
                    <div className="col-span-4"><strong className="text-lg">{seatingName}</strong></div>
                    <div className="col-span-6"><strong>Created By:</strong> {createdBy}</div>
                </div>
                
            </div>

            <div className="border-b border-black my-2"></div>

            {/* Items details Headers */}
            <div className="grid grid-cols-12 font-bold text-[14px] mb-1">
                <span className="col-span-10">Item</span>
                <span className="col-span-2 text-center">Qty</span>
            </div>
            
            <div className="border-b border-dashed border-black mb-2"></div>

            {/* Products list items loop layout mapping */}
            <div className="space-y-2 text-[18px]">
                {displayProducts.map((item, index) => {
                    const name = item.name || item.productName || item.title || "Unknown";
                    const qty = item.quantity || item.qty || 1;
                    // const price = item.price || item.rate || 0;

                    return (
                        <div key={index} className="grid grid-cols-12 items-start leading-6">
                            <span className="col-span-10 line-clamp-2 break-words font-medium leading-6">{name}</span>
                            <span className="col-span-2 text-center font-bold">{qty}</span>
                        </div>
                    );
                })}
            </div>

            <div className="border-b border-dashed border-black my-3"></div>

            {/* Footer details */}
            {<div className="text-center space-y-1 mt-1 mb-2">
                <p className="text-[14px] mt-2 font-semibold">Thank You! Visit Again</p>
                <p className="text-[12px] mt-2 font-semibold">Powered by RestoPOS Engine</p>
            </div>}
        </div>
    );
}